// Only tenants with a published manual are exposed in the user menu.
// Keep this lightweight: the full content belongs to the lazy-loaded page.
const TENANT_HELP = Object.freeze({
  macmillan: Object.freeze({
    slug: 'macmillan',
    companyName: 'Macmillan Education',
    title: 'Documentação SalesFlow',
    description: 'Seu guia para pedidos, doações, budget e Portal do Cliente.',
    videosUrl: 'https://drive.google.com/drive/folders/1g0VYn-GIKq8L97rTf_KvUkZYHaK8cyM1?usp=drive_link',
  }),
});

function getTenantHelpConfig(slug) {
  const normalized = typeof slug === 'string' ? slug.trim().toLowerCase() : '';
  return Object.prototype.hasOwnProperty.call(TENANT_HELP, normalized)
    ? TENANT_HELP[normalized]
    : null;
}

module.exports = { getTenantHelpConfig };